export const rootPaths = {
  root: "/",
  dashboardRoot: "dashboard",
  appsRoot: "app",
  emailRoot: "email",
  eventsRoot: "events",
  socialRoot: "social",
  eCommerceRoot: "e-commerce",
  productRoot: "product",
  eLearningRoot: "e-learning",
  supportDeskRoot: "support-desk",
  componentsRoot: "components",
  pagesRoot: "pages",
  authRoot: "authentication",
  authSimpleRoot: "simple",
  authCardRoot: "card",
  authSplitRoot: "split",
  userRoot: "user",
  pricingRoot: "pricing",
  faqRoot: "faq",
  errorsRoot: "errors",
  miscRoot: "miscellaneous",
  formsRoot: "forms",
  basicFormsRoot: "basic",
  advanceFormsRoot: "advance",
  tableRoot: "tables",
  chartsRoot: "charts",
  echartsRoot: "echarts",
  iconsRoot: "icons",
  mapsRoot: "maps",
  carouselRoot: "carousel",
  navsAndTabsRoot: "navs-and-tabs",
  picturesRoot: "pictures",
  videosRoot: "videos",
  utilitiesRoot: "utilities",
  docRoot: "documentation",
  layoutRoot: "layouts",
};

export default {
  changelog: "/changelog",
  widgets: "/widgets",
  landing: "/landing",
  starter: `/${rootPaths.pagesRoot}/starter`,
  //error404: `/${rootPaths.errorsRoot}/404`,
  //error500: `/${rootPaths.errorsRoot}/500`,
  simpleLogin: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/login`,
  splitLogin: `/${rootPaths.authRoot}/${rootPaths.authSplitRoot}/login`,
  fontAwesome: `/${rootPaths.iconsRoot}/font-awesome`,
  reactIcons: `/${rootPaths.iconsRoot}/react-icons`,
  analytics: `/${rootPaths.dashboardRoot}/analytics`,
  reporte_consumo: "/reporte_consumo",
  reporte_bitacora: "/reporte_bitacora",
  reporte_alertas: "/reporte_alertas",
  reporte_usabilidad: "/reporte_usabilidad",
  reporte_recorridos: "/reporte_recorridos",
  reporte_estadias: "/reporte_estadias",
  reporte_puntocercano: "/reporte_puntocercano",
  reporte_km: "/reporte_km",
  reporte_paradas_no_autorizadas: "/reporte_paradas_no_autorizadas",
  reporte_temperatura: "/reporte_temperatura",
  reporte_apagados_encendidos: "/reporte_apagados_encendidos",
  reporte_horario_no_laboral: "/reporte_horario_no_laboral"
};
